import { SPECS, FINAL_CTA } from "../../data/content";
import Reveal from "./Reveal";

function SpecGroup({ title, rows, testId }) {
  return (
    <div data-testid={testId} className="border-t border-white/15">
      <div className="py-5 overline">{title}</div>
      <dl className="divide-y divide-white/10 border-t border-white/15">
        {rows.map((r) => (
          <div
            key={r.k}
            className="grid grid-cols-12 gap-4 py-5 md:py-6 items-baseline"
          >
            <dt className="col-span-12 md:col-span-4 font-serif-display text-white/90 text-lg md:text-xl font-light">
              {r.k}
            </dt>
            <dd className="col-span-12 md:col-span-5 text-[#D4C9A8] text-base font-light tracking-wide">
              {r.v}
            </dd>
            {r.note && (
              <dd className="col-span-12 md:col-span-3 text-xs uppercase tracking-[0.18em] text-white/40 md:text-right">
                {r.note}
              </dd>
            )}
          </div>
        ))}
      </dl>
    </div>
  );
}

export default function Specifications() {
  return (
    <section
      id="specifications"
      data-testid="specifications-section"
      className="relative bg-[#050B14] py-24 md:py-40"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 lg:col-span-7">
            <Reveal>
              <div className="flex items-center gap-4 mb-8">
                <div className="h-px w-12 bg-[#E5D3B3]" />
                <span className="overline">{SPECS.overline}</span>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <h2
                data-testid="specs-headline"
                className="font-serif-display text-white text-[clamp(2.25rem,5vw,4.5rem)] leading-[1.05] font-light tracking-[-0.02em] whitespace-pre-line"
              >
                {SPECS.title}
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 lg:col-span-4 lg:col-start-9 self-end">
            <Reveal delay={0.25}>
              <p className="text-[#D4C9A8] text-base font-light leading-relaxed">
                Three layers: verified facts, public-source figures, items to confirm on enquiry.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="space-y-12 md:space-y-16">
          <Reveal>
            <SpecGroup
              title="Verified"
              rows={SPECS.verified}
              testId="specs-verified"
            />
          </Reveal>
          <Reveal>
            <SpecGroup
              title="Public sources · values vary"
              rows={SPECS.publicSource}
              testId="specs-public"
            />
          </Reveal>
          <Reveal>
            <SpecGroup
              title="To confirm on enquiry"
              rows={SPECS.toConfirm}
              testId="specs-confirm"
            />
          </Reveal>
        </div>

        <Reveal>
          <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <span className="overline">Full dossier — all specifications, layouts & history</span>
            <a
              href={FINAL_CTA.dossierUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="specs-dossier-link"
              className="link-underline font-serif-display italic text-[#E5D3B3] text-lg md:text-xl"
            >
              Open PDF dossier →
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
